// @flow

import React from "react";
import classNames from "classnames";

type ListItem = $Exact<{
  value: string,
  key: string,
  className?: string,
}>;

type Props = $Exact<{
  title?: string,
  listClassName?: string,
  titleClassName?: string,
  list: ListItem[],
}>;

class List extends React.Component<Props> {
  get list() {
    return this.props.list || [];
  }

  render() {
    const { title, listClassName, titleClassName } = this.props;
    return (
      <div>
        {title && (
          <h4
            className={classNames("font-size-24 font-weight-bold", {
              [titleClassName || ""]: titleClassName,
            })}
          >
            {title}
          </h4>
        )}
        <ul
          className={classNames("list-component", {
            [listClassName || ""]: listClassName,
          })}
        >
          {this.list.map(el => (
            <li key={el.key} className={el.className || ""}>
              {el.value}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default List;
